import { FileSpreadsheet, FileText } from "lucide-react";
import { runExport } from "@/shared/lib/exportCsv";

const BUTTON_CLASS =
  "inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-border bg-card px-3.5 text-sm font-medium text-foreground shadow-[var(--shadow-sm)] transition-colors duration-150 hover:border-accent hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent";

/** PDF et Excel d'un tableau : la page fournit toutes les lignes filtrées, pas seulement la page affichée. */
export function ExportMenu({ onExport }: { onExport: () => void; label?: string }) {
  return (
    <div className="inline-flex gap-2" data-table-export>
      <button type="button" onClick={() => runExport("pdf", onExport)} className={BUTTON_CLASS}>
        <FileText size={15} strokeWidth={2} aria-hidden="true" />
        PDF
      </button>
      <button type="button" onClick={() => runExport("excel", onExport)} className={BUTTON_CLASS}>
        <FileSpreadsheet size={15} strokeWidth={2} aria-hidden="true" />
        Excel
      </button>
    </div>
  );
}
